export default __webpack_public_path__ + "static/media/culbot-equipment.d88cb19f.svg";